<template>
  <div id="pg-ew"></div>
</template>

<script>
  import { mapState } from 'vuex'
  import conf from 'conf'

  export default {
    computed: {
      ...mapState('main', ['selectedLang']),
      plusgradeApiKey() {
        return conf.plusgradeApiKey
      },
      plusgradePid() {
        return conf.plusgradePid
      },
      isProductionEnv() {
        console.log(conf.env)
        return conf.env !== 'test'
      }
    },
    mounted() {
      this.initPlusgrade()
    },
    methods: {
      initPlusgrade() {
        this.plusgradeForTesting()
        this.plusgradeWidget()
      },
      plusgradeForTesting() {
        if (this.isProductionEnv) return

        const url = 'https://canvas-stg.stage.plusgrade.com/env/env.js'
        const script = document.querySelector(`script[src="${url}"]`)

        if (typeof script === 'undefined' || script === null) {
          const plusgradeScript = document.createElement('script')
          plusgradeScript.setAttribute('src', `${url}`)
          plusgradeScript.setAttribute('type', 'text/javascript')
          plusgradeScript.setAttribute('id', '__pg_eligibility_widget_env__')
          document.head.appendChild(plusgradeScript)
        }
      },
      plusgradeWidget() {
        let url = this.isProductionEnv ? 'https://canvas' : 'https://canvas-stg.stage'
        url += '.plusgrade.com/eligibilityWidget/eligibilityWidget.js'

        const script = document.querySelector(`script[src="${url}"]`)

        if (typeof script === 'undefined' || script === null) {
          const plusgradeScript = document.createElement('script')
          plusgradeScript.setAttribute('src', `${url}`)
          plusgradeScript.setAttribute('type', 'text/javascript')
          plusgradeScript.setAttribute('id', '__pg_eligibility_widget__')

          plusgradeScript.onload = () => {
            window?.PGEligibilityWidget?.initialize(
              'pg-ew',
              this.plusgradePid,
              this.plusgradeApiKey,
              this.selectedLang
            )
          }

          document.head.appendChild(plusgradeScript)
        }
      }
    }
  }
</script>
